import './jquery-oembed-all/jquery.oembed';
import './jquery-oembed-all/jquery.oembed.css';

const replaceOEmbed = (wrapper, text) => {

    if (typeof text === 'undefined') {
        return;
    }
    try {
        const provider = wrapper.data('oembed_provider');
        text = text.replace(/(\s|>|^)(https?:[^\s<]*)/igm, '<a href="$2" class="oembed">$2</a>');
        wrapper.html(text)

        const om = wrapper.find('.oembed').oembed(null, {
            embedMethod: 'auto',	// "auto", "append", "fill","replace"
            apikeys: {
                // amazon : '<your amazon key>',
            },
            afterEmbed: function (container, oembedData,externalUrl) {
                // const el = $(container.code);
                wrapper.addClass('embeddedContent-loaded');

                if (provider === 'facebook'){
                    if (typeof window.FB !== 'undefined' && !wrapper.find('iframe').length){
                        setTimeout(function (){
                            console.log('wrapper',wrapper.find('iframe').length)
                            window.FB.init({
                                xfbml      : true,
                                version    : 'v8.0'
                            });
                        },1000);
                    }
                }

            },
            onError: function (container, externalUrl, embedProvider) {
                console.log('onError', this)
            }

        });
        // console.log('om', om)
    } catch (e) {
        console.error(e)
    }


}
export const loadItemEmbedded = () => {
    if ($(".default-item__content .embeddedContent").length) {
        $.each($(".default-item__content .embeddedContent"), function (index, el) {
            if (!$(el).closest('.embeddedContent-loaded').length) {
                $(el).wrap('<div class="embeddedContent--loaded"></div>');
                let text = $(el).data('oembed');
                replaceOEmbed($(el), text);

            }
        })
    }
}
(() => {

setTimeout(function (){
    loadItemEmbedded();
},1000)

})();



// WEBPACK FOOTER //
// ./src/scripts/oembed.js